'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row, Typography } from '@repo/ui/components'

export const PasswordCTA = () => {
  const { t } = useTranslate()
  return (
    <Row className='bg-neutral-surface-light p-xs md:p-0 gap-xs'>
      <ButtonLink
        variant='transparent'
        size='md'
        color='neutral'
        href='/profile'
        aria-label='Back to Profile'
        endIcon={<Icon name='ArrowRightLine' size='md' />}
      />

      <Typography size='md' weight='bold'>
        {t('profileLayout_password')}
      </Typography>
    </Row>
  )
}
